import { j as s } from "../../jsx-runtime-Wav_3Wde.js";
import e from "../BaseIcon.mjs";
const a = (o) => /* @__PURE__ */ s.jsx("svg", {
  viewBox: "0 0 24 24",
  "aria-label": "(opens in new tab)",
  ...o,
  children: /* @__PURE__ */ s.jsx("g", {
    children: /* @__PURE__ */ s.jsx("path", {
      d: "M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M16,17.47H6.5V8.03h4v1.5H8v6.44h6.5   v-2.5H16V17.47z M17.5,11.03l-1.72-1.72l-4.58,4.58l-1.06-1.06l4.58-4.58L13,6.53l4.5,0V11.03z"
    })
  })
}), t = (o) => /* @__PURE__ */ s.jsx(e, {
  IconSvg: a,
  ...o
});
export {
  t as default
};
